// Lib
import { useEffect, useRef } from 'react';

function usePrevious<T>(value: T): T;

function usePrevious<T>(value: T, initialValue?: T): T | undefined {
    const ref = useRef(initialValue);
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
}

export default usePrevious;
